import './Bookmarklets.scss';
import React from 'react';

export class Bookmarklets extends React.Component {
	render() {
		return (
			<iframe src={`https://www.bagnall.co.uk/bookmarklets/`} alt={`bookmarklets`} title={`bookmarklets`}/>
		);
	}
}